module.exports = __webpack_public_path__ + "img/sh.cff103f5.png";